<template>
  <div
    class="input-field has-icon"
    :class="error ? 'has-error' : null"
    ref="input-field"
  >
    <label v-if="label" :for="inputId" class="pointer">{{ label }}</label>

    <template v-if="icon || prefixIcon">
      <div class="icon-container">
        <i
          v-if="prefixIcon"
          class="material-icons prefix"
          :class="prefixIconClickable ? 'clickable' : null"
          @click="prefixIconClick"
          ref="prefix-icon"
        >
          {{ prefixIcon }}
        </i>
        <input
          :class="classes"
          :type="type"
          :id="inputId"
          :name="inputId"
          :placeholder="placeholder"
          :autofocus="focus"
          @focus="inputFocus"
          @blur="inputBlur"
          @keyup="inputKeyUp"
          ref="input"
        />
        <i
          v-if="icon"
          class="material-icons"
          :class="iconClickable ? 'clickable' : null"
          @click="iconClick"
          ref="icon"
          >{{ icon }}</i
        >
      </div>
    </template>
    <template v-else>
      <input
        :class="classes"
        :type="type"
        :id="inputId"
        :name="inputId"
        :placeholder="placeholder"
        :autofocus="focus"
        @focus="inputFocus"
        @blur="inputBlur"
        @keyup="inputKeyUp"
        ref="input"
      />
    </template>

    <span class="help-text">{{ error }}</span>
  </div>
</template>

<script>
export default {
  name: "InputField",
  computed: {
    inputId() {
      return this.id || this.label;
    },
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
    classes: {
      type: String,
      default: "",
    },

    inline: {
      type: Boolean,
      default: false,
    },
    focusClass: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    iconClickable: {
      type: Boolean,
      default: false,
    },
    prefixIcon: {
      type: String,
      default: "",
    },
    prefixIconClickable: {
      type: Boolean,
      default: false,
    },
    focus: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(newValue) {
      this.setInputFieldValue(newValue)
    },
  },
  mounted() {
    if (this.inline) this.$refs["input-field"].classList.add("inline");
    if (this.prefixIcon)
      this.$refs["input-field"].classList.add("has-prefix-icon");

    this.setInputFieldValue();
    setTimeout(() => {
      if (this.focus) this.$refs.input.focus();
    }, 0);
  },
  methods: {
    setInputFieldValue(value = this.value) {
      const input = this.$refs["input"];
      input.value = value;
    },
    iconClick(event) {
      if (this.iconClickable) this.$emit("iconClick", event, this.$refs.input);
    },
    prefixIconClick(event) {
      if (this.prefixIconClickable)
        this.$emit("prefixIconClick", event, this.$refs.input);
    },
    inputKeyUp(event) {
      this.$emit("keyup", event);
    },

    inputFocus(e) {
      if (this.focusClass) {
        e.target.classList.add(this.focusClass);
        if (this.icon) this.$refs.icon.classList.add(this.focusClass);
      }

      this.$emit("focus", e);
    },
    inputBlur(e) {
      if (this.focusClass) {
        e.target.classList.remove(this.focusClass);
        if (this.icon) this.$refs.icon.classList.remove(this.focusClass);
      }

      this.$emit("blur", e);
    },
  },
};
</script>

<style lang="scss" scoped>
$error-c: lighten($error, 15);
.has-error {
  label,
  .help-text,
  .material-icons {
    color: $error-c !important;
  }

  input {
    border-color: $error-c !important;
    background-color: $error-tint !important;
  }
}

.has-icon {
  i.materrial-icons {
    right: 8px;
  }
}

.has-prefix-icon {
  input {
    padding-left: 32px !important;
  }

  .icon-container {
    .material-icons.prefix {
      left: 8px;
    }
  }
}
</style>
